export default __webpack_public_path__ + "static/media/et.5c4f6d95.svg";